module.exports = __webpack_public_path__ + "img/5ECBA4_BCFAE7_92EED0_A1F4DC-256px.a6080457.png";